import React from 'react';
import OrgActivityFeed from './OrgActivityFeed';
import CurrentActivations from '@/src/Activations/components/CurrentActivations';
import { Button } from '@/src/shadComponents/ui/button';
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();
    return (
        <div className="flex h-full">
            <main className="flex-1 p-6 overflow-auto">
                <header className="flex items-end justify-between pb-4 border-b border-border">
                    <div>
                        <h1 className="text-2xl font-bold tracking-tight text-foreground">
                            Dashboard
                        </h1>
                        <p className="text-sm text-muted-foreground mt-1">
                            Your recent activations and activity.
                        </p>
                    </div>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => navigate('/activations')}
                    >
                        View All &rarr;
                    </Button>
                </header>
                <CurrentActivations />
            </main>
            <aside className="hidden lg:block w-96 border-l border-border overflow-y-auto">
                <div className="p-4 border-b border-border">
                    <h2 className="text-sm font-semibold text-foreground uppercase tracking-wide">
                        Activity Feed
                    </h2>
                </div>
                <div className="p-4">
                    <OrgActivityFeed />
                </div>
            </aside>
        </div>
    );
}
